import { find_guide, type HelpGuide } from "@/help/guides"

/**
 * The API reference shown under Settings › API Keys. It is the `help/api.md` guide — the same file
 * the in-app help renders at `/help/api` and the MCP server serves (`get_help_guide` slug `api`,
 * resource `marginwiz://help/api`) — so the page, the download and an agent read one text.
 */
export const API_DOCS_SLUG = "api"

export function api_docs_guide(): HelpGuide | undefined {
  return find_guide(API_DOCS_SLUG)
}

/** PURE: the file a brand downloads to send to its engineer, dated so copies can be told apart. */
export function api_docs_download(guide: HelpGuide, today: string): { filename: string; content: string } {
  return {
    filename: `marginwiz-api-docs-${today}.md`,
    content: `${guide.body}\n\n---\n\nDownloaded ${today}. The current version is always in MarginWiz under Settings › API Keys, and available to AI agents over MCP (\`get_help_guide\` with slug \`api\`).\n`,
  }
}

if (import.meta.vitest) {
  const { describe, expect, it } = import.meta.vitest
  describe("api docs", () => {
    it("is the help/api.md guide", () => {
      const guide = api_docs_guide()
      expect(guide?.title).toBe("API and MCP reference")
      expect(guide?.body).toContain("https://www.marginwiz.com/api")
      expect(guide?.body).toContain("https://mcp.marginwiz.com/mcp")
    })
    it("download is dated markdown without front matter", () => {
      const guide = { slug: "api", title: "T", summary: "S", body: "# T\n\nbody" }
      const file = api_docs_download(guide, "2026-10-26")
      expect(file.filename).toBe("marginwiz-api-docs-2026-10-26.md")
      expect(file.content.startsWith("# T\n\nbody")).toBe(true)
      expect(file.content).toContain("Downloaded 2026-10-26")
    })
    it("never links app.marginwiz.com", () => {
      expect(api_docs_guide()?.body).not.toContain("app.marginwiz.com")
    })
  })
}
